import { isTerminalJobStatus } from '../../services/batchJobsService';

// Poll cadence per spec: 5s while pending/running, 30s while paused, stop on terminal.
export const getJobPollIntervalMs = (status) => {
  if (isTerminalJobStatus(status)) return null;
  if (status === 'paused') return 30000;
  return 5000;
};

export const JOB_STATUS_META = {
  pending: { label: 'Pending', color: 'default' },
  running: { label: 'Running', color: 'info' },
  paused: { label: 'Paused', color: 'warning' },
  completed: { label: 'Completed', color: 'success' },
  completed_with_errors: { label: 'Completed with errors', color: 'warning' },
  failed: { label: 'Failed', color: 'error' },
  cancelled: { label: 'Cancelled', color: 'default' },
};

export const getJobStatusMeta = (status) =>
  JOB_STATUS_META[status] || { label: status || 'Unknown', color: 'default' };

// updated_at is a heartbeat; older than ~30 min while running means the backend
// watchdog is recovering the job.
export const isJobStale = (job) => {
  if (!job || job.status !== 'running' || !job.updated_at) return false;
  const updated = new Date(job.updated_at).getTime();
  return Number.isFinite(updated) && Date.now() - updated > 30 * 60 * 1000;
};

export const formatJobDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
};

export const formatJobElapsed = (job) => {
  if (!job?.started_at) return '—';
  const start = new Date(job.started_at).getTime();
  const end = job.completed_at ? new Date(job.completed_at).getTime() : Date.now();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return '—';
  const totalSeconds = Math.floor((end - start) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
};

// Scalar source records are wrapped as {"value": "..."} — unwrap for display.
export const unwrapItemInput = (inputData) => {
  if (
    inputData &&
    typeof inputData === 'object' &&
    !Array.isArray(inputData) &&
    Object.keys(inputData).length === 1 &&
    Object.prototype.hasOwnProperty.call(inputData, 'value')
  ) {
    return inputData.value;
  }
  return inputData;
};

export const formatItemInputPreview = (inputData, maxLength = 120) => {
  const unwrapped = unwrapItemInput(inputData);
  const text =
    typeof unwrapped === 'string' ? unwrapped : JSON.stringify(unwrapped);
  if (!text) return '—';
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
};
